/**
 * @generated SignedSource<<f792f8e7dc037abcb427c6104481635b>>
 * @relayHash 1380d721b18915720bbca11b40e27b39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fff74428c768ff9ead961fcc85650bd1e66c4e039411390b08d38d160e9ec27d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fff74428c768ff9ead961fcc85650bd1e66c4e039411390b08d38d160e9ec27d",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
